import React, { Component } from 'react';
import { connect } from 'react-redux';
import { loginApp, loginAppDirectly } from '../../redux/actions/app';
import { signUpApp } from '../../redux/actions/app';
// import Toggle from '../components/Toggle.jsx'
import { withTranslation  } from 'react-i18next';
import Language from './Language.jsx';

export class Login extends Component {
  constructor(props){
    super(props);
    this.state = {
      mode: 0
    };
  }

  login = (e) => {
    e.preventDefault();
    let form = document.getElementById('login').elements;
    let email = form[0].value;
    let password = form[1].value;
    this.props.dispatch(loginApp(email, password));
  }

  signup = (e) => {
    e.preventDefault();
    let form = document.getElementById('login').elements;
    let username = form[0].value;
    let email = form[1].value;
    // let password = form[2].value;
    // let confirm = form[3].value;

    // if (password !== confirm) {
    //   alert('passwords do not match.');
    // } else {
    // this.props.dispatch(signUpApp(username, email, password));
    this.props.dispatch(signUpApp(username, email));
    let tempState = {...this.state};
    tempState.mode = 0;
    this.setState(tempState);
    // }
  }

  changeMode = (i) => {
    let tempState = {...this.state};
    tempState.mode = i;
    this.setState(tempState);
  }

  useQuery() {
    return new URLSearchParams(window.location.search);
  }

  render() {
    const { t } = this.props;
    let button = t('common.LoginBtn');
    let submit = this.login;
    if (this.state.mode === 1) {
      button = t('common.SignUpBtn');
      submit = this.signup;
    }

    let showLoginForm = false
    let query = this.useQuery();
    const prefillEmail = query.get("email") ? query.get("email") : '';
    if (!query.get("isLoginDirectly") ||  !query.get("email")) {
      showLoginForm = true
    } else if (query.get("isLoginDirectly") && query.get("email")) {
      this.props.dispatch(loginAppDirectly(query.get("email")));
      query.delete("isLoginDirectly");
      window.history.replaceState(null, null, window.location.origin + '?' + query.toString());
    }

    return (
      <div className="login">
        {/* <Toggle
          mode={this.state.mode}
          changeMode={this.changeMode}
        /> */}
        <Language />
        <form id="login" onSubmit={submit} style={{display: showLoginForm ? '' : 'none'}}>
          <h1>APM WONDERLAND PROGRAM</h1>

          <div className='email-box'>
            <div className='email-title'>{ t('common.email') }:</div>
            <input className="input" required type="text" placeholder="" defaultValue={prefillEmail}></input>
          </div>

          {this.state.mode === 1 && <input className="input" required type="email" placeholder="Email"></input>}

          {/* <input className="input" required type="password" placeholder="Password"></input> */}

          {/* {this.state.mode === 1 && <input className="input" required type="password" placeholder="Confirm Password"></input>} */}

          {this.state.mode === 0 && <button type="submit" className="button-secondary uppercase">{ t('common.LoginBtn') }</button>}

          {this.state.mode === 1 && <button type="submit" className="button-secondary uppercase">{ t('common.SignUpBtn') }</button>}
        </form>
      </div>
    );
  }
}

export default connect()(withTranslation()(Login));



// WEBPACK FOOTER //
// ./src/js/containers/Login.jsx